import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Input } from './ui/input';
import { Search, X } from 'lucide-react';
import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SearchBar = ({ isOpen, onClose }) => {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
    if (!isOpen) {
      setQuery('');
    }
  }, [isOpen]);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setLoading(true);
    try {
      const { data } = await axios.get(
        `${BACKEND_URL}/api/wiki/search?q=${encodeURIComponent(query.trim())}`,
        { withCredentials: true }
      );

      if (data.exact_match) {
        navigate(`/wiki/${data.exact_match.id}`);
        onClose();
      } else {
        navigate(`/search?q=${encodeURIComponent(query.trim())}`);
        onClose();
      }
    } catch (err) {
      console.error('Search error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="sticky top-[calc(theme(spacing.24)+theme(spacing.5)*2+2px)] bg-background/95 backdrop-blur border-b border-border z-40" data-testid="search-bar">
      <div className="container mx-auto px-6 py-4">
        <form onSubmit={handleSearch} className="flex items-center gap-3 max-w-2xl mx-auto">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" aria-hidden="true" />
            <Input
              ref={inputRef}
              type="text"
              placeholder="Search the glossary..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="pl-10 bg-input/50 border-border rounded-sm font-sans text-lg h-12 focus-visible:ring-primary"
              data-testid="search-input"
            />
          </div>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onClose}
            data-testid="search-close-button"
          >
            <X className="w-5 h-5" aria-hidden="true" />
          </Button>
        </form>
      </div>
    </div>
  );
};

export default SearchBar;
